import { render, staticRenderFns } from "./slide-portrait.vue?vue&type=template&id=595499f2&"
import script from "./slide-portrait.vue?vue&type=script&lang=js&"
export * from "./slide-portrait.vue?vue&type=script&lang=js&"
import style0 from "./slide-portrait.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports